import UploadButton from "./UploadButton";
import asUploadButton from "./asUploadButton";
export default UploadButton;
export { UploadButton, asUploadButton };